import { render, staticRenderFns } from "./JuminChuyou.vue?vue&type=template&id=a0008854&scoped=true&"
import script from "./JuminChuyou.vue?vue&type=script&lang=js&"
export * from "./JuminChuyou.vue?vue&type=script&lang=js&"
import style0 from "./JuminChuyou.vue?vue&type=style&index=0&id=a0008854&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0008854",
  null
  
)

export default component.exports